<div id="header-root">
    <div id="desktop-header">
        <a class="logo" href="/"><img class="logo-img" src="/images/logo-full.png"></a>
    </div>
</div>